/* istanbul ignore file */
import { useFieldHelper } from 'framework/ui/field';
import { VacancyEnumFieldProps } from './VacancyEnumUtils';
import { CustomBadge } from 'framework/ui/ui-builder';
import { ChipOwnProps } from '@mui/material';

const VacancyStatusField = ({ value: inputValue, source, ...props }: VacancyEnumFieldProps) => {
  const { getValue } = useFieldHelper({ value: inputValue, source });

  const value = inputValue || getValue();

  const getColor = (): ChipOwnProps['color'] => {
    switch (value) {
      case 'OPEN':
        return 'success';
      case 'DRAFT':
        return 'primary';
      default:
        return 'default';
    }
  };

  return <CustomBadge text={value} color={getColor()} {...props} />;
};

export default VacancyStatusField;
